import * as React from "react";
import Image from "next/image";
import styles from "./weddingPartyModal.module.scss";
import { shimmer, toBase64 } from "@src/utils/shimmer";
import flowerBackground from "../../../../public/images/bw-flower.jpeg";

interface WeddingPartyModalProps {
  name: string;
  nickname?: string;
  role: string;
  story: string;
  imageUrl: string;
}

const WeddingPartyModal: React.FC<WeddingPartyModalProps> = ({
  name,
  nickname,
  role,
  story,
  imageUrl,
}) => {
  return (
    <div className={styles["wedding-party-modal"]}>
      <div className={styles["wedding-party-modal__content"]}>
        <div className={styles["wedding-party-modal__image-container"]}>
          <Image
            placeholder="blur"
            blurDataURL={`data:image/svg+xml;base64,${toBase64(
              shimmer(400, 500)
            )}`}
            layout="fill"
            objectFit="cover"
            src={imageUrl || flowerBackground}
            alt={name}
            onError={(event) => {
              const target = event.currentTarget as HTMLImageElement;
              if (!target.src.includes("bw-flower.jpeg")) {
                target.src = flowerBackground.src;
              }
            }}
          />
        </div>

        <div className={styles["wedding-party-modal__text-content"]}>
          <div className={styles["wedding-party-modal__header"]}>
            <h2
              className={`${styles["wedding-party-modal__name"]} font-corGaramond`}
            >
              {name}
              {nickname && (
                <span
                  className={`${styles["wedding-party-modal__nickname"]} font-inter`}
                >
                  "{nickname}"
                </span>
              )}
            </h2>
            <p className={`${styles["wedding-party-modal__role"]} font-jost`}>
              {role}
            </p>
          </div>

          <div className={styles["wedding-party-modal__story"]}>
            <article className="font-corGaramond">{story}</article>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WeddingPartyModal;
